import { h as head, e as escape_html, k as ensure_array_like, b as attr, p as pop, a as push } from "../../../../chunks/index2.js";
import "@sveltejs/kit/internal";
import "../../../../chunks/exports.js";
import "../../../../chunks/utils.js";
import "../../../../chunks/state.svelte.js";
import { g as getToastState } from "../../../../chunks/Toast.svelte.js";
function _page($$payload, $$props) {
  push();
  getToastState();
  let { data } = $$props;
  let categories = data.categories || [];
  head($$payload, ($$payload2) => {
    $$payload2.title = `<title>Categories</title>`;
  });
  $$payload.out.push(`<div class="container mx-auto p-6"><div class="mb-6"><div class="mb-4 flex items-center justify-between"><h1 class="text-3xl font-bold">Categories Management</h1> <button class="bg-primary hover:bg-primary/90 rounded-lg px-4 py-2 text-white">${escape_html("Add Category")}</button></div> `);
  {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--> <div class="overflow-x-auto rounded-md border border-gray-200 bg-white"><table class="min-w-full divide-y divide-gray-200"><thead class="bg-gray-50"><tr><th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Name</th><th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th></tr></thead><tbody class="divide-y divide-gray-200">`);
  if (categories.length === 0) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<tr><td class="px-6 py-4 text-center text-sm text-gray-500" colspan="2">No categories found</td></tr>`);
  } else {
    $$payload.out.push("<!--[!-->");
    const each_array = ensure_array_like(categories);
    $$payload.out.push(`<!--[-->`);
    for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
      let category = each_array[$$index];
      $$payload.out.push(`<tr class="hover:bg-gray-50"><td class="px-6 py-4"><div class="text-sm font-medium text-gray-900">${escape_html(category.name)}</div></td><td class="px-6 py-4"><div class="flex space-x-5"><a${attr("href", `/admin/category/${category.id}`)} class="text-primary hover:text-primary/80">Edit</a> <form method="POST" action="?/delete_category"><input type="hidden" name="id"${attr("value", category.id)}/> <button type="submit" class="text-red-600 hover:text-red-800">Delete</button></form></div></td></tr>`);
    }
    $$payload.out.push(`<!--]-->`);
  }
  $$payload.out.push(`<!--]--></tbody></table></div></div></div>`);
  pop();
}
export {
  _page as default
};
